/** Tipos de lançamentos utilizados na aplicação */
export interface Lancamento {
    id: number;
    nome: string;
}

export const lancamentoQuantidade: Lancamento = {id: 1, nome: 'Quantidade'};
export const lancamentoPeso: Lancamento = {id: 2, nome: 'Peso'};
export const lancamentoValor: Lancamento = {id: 3, nome: 'Valor'};
export const lancamentoPercentual: Lancamento = {id: 4, nome: 'Percentual'};

/** Tipos de lançamentos utilizados na aplicação */
export const lancamentos: Lancamento[] = [
    lancamentoQuantidade,
    lancamentoPeso,
    lancamentoValor,
    lancamentoPercentual
];

/** Verifica se o lançamento é por quantidade */
export function isLancamentoQuantidade(id: number): boolean {
    return id === lancamentoQuantidade.id;
}

/** Verifica se o lançamento é por peso */
export function isLancamentoPeso(id: number): boolean {
    return id === lancamentoPeso.id;
}

/** Verifica se o lançamento é por valor */
export function isLancamentoValor(id: number): boolean {
    return id === lancamentoValor.id;
}

/** Verifica se o lançamento é por percentual */
export function isLancamentoPercentual(id: number): boolean {
    return id === lancamentoPercentual.id;
}
